<nz-card [nzTitle]="'Agentes'"  *ngIf="!editing">
  <div style="margin-bottom: 24px; display: flex; gap: 16px; align-items: center;" >
    <input 
      nz-input 
      nzPlaceHolder="Buscar por nome do agente..."
      [(ngModel)]="searchText"
      nzSize="large"
      style="max-width: 400px;">
    <button 
      nz-button 
      nzType="primary" 
      nzSize="large"
      (click)="createAgent()">
      + Novo Agente
    </button>
     <button 
      nz-button 
      nzType="primary" 
      nzSize="large"
      (click)="refreshAgents()">
      Atualizar
    </button>
  </div>
  
  <div class="table-wrapper">
    <nz-table 
      [nzData]="filteredAgents" 
      nzBordered 
      [nzNoResult]="emptyTemplate"
      [nzLoading]="loading"
      [(nzPageIndex)]="pageIndex"
      [nzPageSize]="10"
      class="full-table"
      #tableAgent
      nzTableLayout="fixed"

      [nzScroll]="{ y: 'calc(100vh - 340px)'}">
      <thead>
        <tr>
          <th>{{'agentBuilder.name'|translateTA}}</th>
          <th>{{'agentBuilder.llm'|translateTA}}</th>
          <th>{{'agentBuilder.model'|translateTA}}</th>
          <th>{{'agentBuilder.company'|translateTA}}</th>
          <th>{{'agentBuilder.contract'|translateTA}}</th>
          <th>{{'agentBuilder.modifiedOn'|translateTA}}</th>
          <th>{{'agentBuilder.actions'|translateTA}}</th>
        </tr>
      </thead>
      <tbody>
         @for (agent of tableAgent.data; track agent._id) {
         <tr>
           @let icon = getIcon(agent);
          <td>{{ agent.agentName }}</td>
          <td><nz-icon [nzType]="icon" nzTheme="outline"></nz-icon> {{ agent.llm }}</td>
          <td>{{ agent.model }}</td>
          <td>{{ agent.codecompany.key}} - {{ agent.codecompany.value }}</td>
          <td>{{ agent.codecontract.key}} - {{ agent.codecontract.value }}</td>
          <td>{{ (agent.RECMODIFIEDON) }}</td>
          <td style="white-space: nowrap;">
            <button 
              nz-button 
              nzType="primary" 
              nzSize="small"
              (click)="editAgent(agent)"
              style="margin-right: 8px">
              Editar
            </button>
            <button 
              nz-button 
              nzType="default" 
              nzSize="small"
              (click)="cloneAgent(agent)"
              style="margin-right: 8px">
              Clonar
            </button>
            <button 
              nz-button 
              nzDanger 
              nzSize="small"
              (click)="deleteAgent(agent)">
              Deletar
            </button>
          </td>
        </tr>
        }
      </tbody>
    </nz-table>
  </div>
</nz-card>
<agent-builder-config *ngIf="editing" [form]="form" [editSubject]="editSubject" ></agent-builder-config>

<ng-template #emptyTemplate >
           <nz-empty 
              nzNotFoundContent="Nenhum agente encontrado"
              style="margin: 0">
            </nz-empty>
</ng-template>